import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { environment } from '../environments/environment';
import { User } from './model/user';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
	
	// langue:boolean=false;
	private currentUserSubject: BehaviorSubject<User>;
	public currentUser: Observable<User>;

	constructor(private http: HttpClient) {
		this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
		this.currentUser = this.currentUserSubject.asObservable();
	}
	tokenresp: any;
	private _updatemenu = new Subject<void>();
	get updatemenu() {
	  return this._updatemenu;
	}

	public get currentUserValue(): User {
		return this.currentUserSubject.value;
	}
	GetToken() {
		return localStorage.getItem("currentUser") || '';
	}
	GetRolebyToken(token: any) {
		console.log(token);
		let _token = token.split('.')[2];
		console.log(_token);	
		this.tokenresp = JSON.parse(atob(_token))
		 console.log(this.tokenresp);
		return this.tokenresp.data.groupe;
		// return this.tokenresp.role;
	  }

	GetMenubyrole(role: any) {
		console.log(role);
		return this.http.post(`${environment.urlApi}/api/api/GetMenubyRole.php`, role);
		// return this.http.get(this.apiurl + 'GetMenubyRole/' + role)
	}
	dataBase(data) {		
		// console.log(data);
		return this.http.post(`${environment.urlApi}/api/api/database.php`, data);
	}
	login(username: string, password: string, DBase: string, annee: string, francais: boolean) {
		return this.http
			.post<any>(`${environment.urlApi}/api/api/login.php`, {
				username,
				password,
				DBase,
				annee,
				francais
			})
			.pipe(
				map((user) => {
					// store user details and jwt token in local storage to keep user logged in between page refreshes
					localStorage.setItem('currentUser', JSON.stringify(user));
					this.currentUserSubject.next(user);
					return user;
				})
			);
	}
	logout() {
		// remove user from local storage to log user out
		localStorage.removeItem('currentUser');
		this.currentUserSubject.next(null);
	}
	changePassword(user) {
		return this.http.post(`${environment.urlApi}/api/api/changePassword.php`, user);
	}
	addUser(user) {
		// console.log('salut ', user);
		return this.http.post(`${environment.urlApi}/api/api/addUser.php`, user);
	}
	user(user) {
		return this.http.post(`${environment.urlApi}/api/api/user.php`, user);
	}
	deleteUser(user) {
		return this.http.post(`${environment.urlApi}/api/api/deleteUser.php`, user);
	}
	getLocalStorage(){
		return this.currentUserSubject.value;
	}
}
